/**
 * Token helpers for direct-URL auth (<img src>, <a href>, FormData
 * exports, etc.) where axios `withCredentials` (cookie) isn't enough.
 *
 * Stored in **sessionStorage** (not localStorage) so it expires when the
 * browser tab closes — mitigates XSS persistence vs `localStorage`.
 *
 * The PRIMARY auth in Ekspertium is the httpOnly cookie `ekspertium_auth`
 * set by `/api/auth/login`. This token in sessionStorage is only used by
 * legacy code paths that build URLs directly. New code should rely on
 * cookies (the backend now accepts cookie auth in all download endpoints).
 *
 * As components migrate to cookie-only flows, calls to `getToken()` can
 * be removed and this module eventually deprecated.
 */
const KEY = "dobilas_token";

export function getToken() {
  try {
    return sessionStorage.getItem(KEY) || "";
  } catch (e) {
    return "";
  }
}

export function setToken(token) {
  try {
    if (token) sessionStorage.setItem(KEY, token);
  } catch (e) { /* sessionStorage no disponible */ }
}

export function clearToken() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) { /* sessionStorage no disponible */ }
}
